import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner, Row, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import useCurrency, { baseUrl } from "../../../Utils/FileUpload";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import moment from "moment";
import { exportToPDF } from "../../../Utils/pdfExportUtils";
import { excelExportUtils } from "../../../Utils/excelExportUtils";
interface CallHistory {
  id: string;
  start_time: string;
  end_time: string;
  customer: {
    mobile: string;
  };
  agent: {
    agent_name: string;
    id: string;
  };
  call_date: string;
  duration: number;
  customer_amount: number | string;
  agent_amount: number | string;
  formatted_duration: string;
  customer_amount_without_currency: number | string;
  agent_amount_without_currency: number | string;
}
interface Agent {
  id: number;
  agent_name: string;
}
interface CallHistoryWithFooter extends CallHistory {
  isFooter?: boolean;
}
export default function CallReport() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<CallHistory[]>([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const { currency } = useCurrency();
  const [totalRows, setTotalRows] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [prevPageBeforeSearch, setPrevPageBeforeSearch] = useState<number>(1);
  const [searchTriggered, setSearchTriggered] = useState<boolean>(false);
  const [agents, setAgents] = useState<Agent[]>([]);
  const [selectedAgent, setSelectedAgent] = useState("");
  const fetchData = async (page = 1, perPage = 10) => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}call_history/getallreport`, {
        params: {
          page,
          per_page: perPage,
          search: searchTriggered ? filterText : "",
        from_date: fromDate ? fromDate.toLocaleDateString("en-CA") : null, // "YYYY-MM-DD"
to_date: toDate ? toDate.toLocaleDateString("en-CA") : null,
          agent_name: selectedAgent !== "" ? selectedAgent : null, // ✅ Add this line
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response, "response");

      const data: CallHistory[] = response.data.data;
      // console.log(data, "data");
      setFilteredItems(data);
      setTotalRows(response.data.total);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios.get(`${baseUrl}agent/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const filteredAgent = result.data.filter(
          (agent: any) => agent.is_deleted === 0 && agent.is_active === 1
        );
        setAgents(filteredAgent); // Set in state
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [currentPage, perPage, selectedAgent]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    await fetchData(1, newPerPage);
  };

  const handleSearchClick = async () => {
    setLoading(true);
    try {
      // First update all state
      setSearchTriggered(true);
      setPrevPageBeforeSearch(currentPage);
      setCurrentPage(1);

      // Force state update before API call
      await new Promise((resolve) => setTimeout(resolve, 0));

      // Then make the API call
      const response = await axios.get(`${baseUrl}call_history/getallreport`, {
        params: {
          page: 1,
          per_page: perPage,
          search: filterText, // Always include search text when button is clicked
          from_date: fromDate?.toISOString().split("T")[0],
          to_date: toDate?.toISOString().split("T")[0],
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setFilteredItems(response.data.data);
      setTotalRows(response.data.total);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateFilterClick = () => {
    if (fromDate && toDate && fromDate > toDate) {
      toast.error("From date cannot be greater than To date.");
      return;
    }
    setSearchTriggered(true);
    fetchData(currentPage, perPage);
  };


///datereset
useEffect(() => {
  if (fromDate === null && toDate === null) {
    fetchData(currentPage, perPage);
  }
}, [fromDate, toDate]);
  const handleDateReset = () => {
    setFromDate(null);
    setToDate(null);
  };


//searchreset
  useEffect(() => {
    if (
      !searchTriggered &&
      filterText === ""
    ) {
      fetchData(currentPage, perPage);
    }
  }, [searchTriggered, filterText]);
  const handleSearchReset = () => {
    setFilterText("");
    setSearchTriggered(false);
  };



  const getCallHistoryColumns = () => {
    return [
      {
        name:  <div>Customer Mobile</div>,
        selector: (row: CallHistory) => row.customer?.mobile,
        // sortable: true,
      },
      {
        name:  <div>Agent Name</div>,
        selector: (row: CallHistory) => row.agent?.agent_name,
        // sortable: true,
      },
      {
        name:  <div>Call Date</div>,
        cell: (row: CallHistoryWithFooter) => {
          if (row.isFooter) {
            return <>Total</>; // just show "Total" for the footer
          }
          const startFormatted = moment(row.start_time, "HH:mm:ss").format(
            "hh:mmA"
          );
          const endFormatted = moment(row.end_time, "HH:mm:ss").format(
            "hh:mmA"
          );
          return <>{`${row.call_date} ${startFormatted} - ${endFormatted}`}</>;
        },
      },
      {
        name:  <div>Duration</div>,
        cell: (row: CallHistoryWithFooter) => {
          if (row.isFooter) {
            return `${row.formatted_duration || row.duration + " mins"}`;
          }
          return row.formatted_duration || "N/A";
        },
      },
      {
        name:  <div>Customer Amount</div>,
        selector: (row: CallHistory) => `${row.customer_amount}` || "N/A",
      },
      {
        name: <div>Agent Amount</div>,
        selector: (row: CallHistory) => `${row.agent_amount}` || "N/A",
      },
    ];
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  const fetchAllDataWithoutPagination = async () => {
    try {
      // console.log(fromDate, toDate, filterText);
      const response = await axios.get(
        `${baseUrl}call_history/getallreportnopagination`,
        {
          params: {
            search: searchTriggered ? filterText : "", // Use the current search filter
            from_date: fromDate ? fromDate.toISOString().split("T")[0] : null, // Use the current from date
            to_date: toDate ? toDate.toISOString().split("T")[0] : null, // Use the current to date
            agent_name: selectedAgent !== "" ? selectedAgent : null, // ✅ Add this line
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response.data.data, "data");
      return response.data.data; // Return the fetched data
    } catch (error) {
      console.error("Error fetching all data without pagination:", error);
      return []; // Return an empty array on error
    }
  };
const calculateTotals = () => {
  const totalDurationInSeconds = filteredItems.reduce((acc, row) => {
    const start = new Date(`1970-01-01T${row.start_time}`);
    const end = new Date(`1970-01-01T${row.end_time}`);
    const diffInSeconds = Math.floor((end.getTime() - start.getTime()) / 1000);
    return acc + diffInSeconds;
  }, 0);

  // Format total duration
  const hours = Math.floor(totalDurationInSeconds / 3600);
  const minutes = Math.floor((totalDurationInSeconds % 3600) / 60);
  const seconds = totalDurationInSeconds % 60;
  
  let formattedTotalDuration = '';
  if (hours > 0) {
    formattedTotalDuration += `${hours}h `;
  }
  if (minutes > 0) {
    formattedTotalDuration += `${minutes}m `;
  }
  if (seconds > 0 || (hours === 0 && minutes === 0)) {
    formattedTotalDuration += `${seconds}s`;
  }
  formattedTotalDuration = formattedTotalDuration.trim();

  const totalCustomerAmount = filteredItems.reduce((acc, row) => {
    const amount = parseFloat(
      (row as any).customer_amount_without_currency || "0"
    );
    return acc + amount;
  }, 0);

  const totalAgentAmount = filteredItems.reduce((acc, row) => {
    const amount = parseFloat(
      (row as any).agent_amount_without_currency || "0"
    );
    return acc + amount;
  }, 0);

  return {
    totalDurationInSeconds,
    formattedTotalDuration,
    totalCustomerAmount,
    totalAgentAmount,
  };
};

const { totalDurationInSeconds, formattedTotalDuration, totalCustomerAmount, totalAgentAmount } =
  calculateTotals();

const columnsData: CallHistoryWithFooter[] = [
  ...filteredItems,
  {
    isFooter: true,
    customer: { mobile: "" },
    agent: { agent_name: "", id: "footer" },
    call_date: "Total",
    duration: totalDurationInSeconds,
    formatted_duration: formattedTotalDuration,
    customer_amount: `${currency ? ` ${currency}` : ""}${totalCustomerAmount.toFixed(2)}`,
    agent_amount: `${currency ? ` ${currency}` : ""}${totalAgentAmount.toFixed(2)}`,
    customer_amount_without_currency: totalCustomerAmount,
    agent_amount_without_currency: totalAgentAmount,
    id: "",
    start_time: "",
    end_time: "",
  },
];
  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row: any) => row.isFooter === true,
      style: {
        fontWeight: "800",
        backgroundColor: "#f8f9fa",
        color: "#308e87",
        borderTop: "2px solid #dee2e6",
        fontSize: "16px",
      },
    },
  ];
const exportPDF = async () => {
  const rawData = await fetchAllDataWithoutPagination();
  const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);

  if (!allData.length) {
    toast.warn("No call report available for export.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
    });
    return;
  }

  // Calculate totals from ALL fetched data
  const totalDurationInSeconds = allData.reduce((acc, row) => {
    return acc + (parseInt(row.duration_seconds) || 0);
  }, 0);

  const hours = Math.floor(totalDurationInSeconds / 3600);
  const minutes = Math.floor((totalDurationInSeconds % 3600) / 60);
  const seconds = totalDurationInSeconds % 60;
  
  let formattedTotalDuration = '';
  if (hours > 0) formattedTotalDuration += `${hours}h `;
  if (minutes > 0) formattedTotalDuration += `${minutes}m `;
  if (seconds > 0 || (hours === 0 && minutes === 0)) formattedTotalDuration += `${seconds}s`;
  formattedTotalDuration = formattedTotalDuration.trim();

  const totalCustomerAmount = allData.reduce((acc, row) => {
    return acc + (parseFloat(row.customer_amount_without_currency) || 0);
  }, 0);

  const totalAgentAmount = allData.reduce((acc, row) => {
    return acc + (parseFloat(row.agent_amount_without_currency) || 0);
  }, 0);

  const tableData = allData.map((row) => {
    const startFormatted = moment(row.start_time, "HH:mm:ss").format("hh:mmA");
    const endFormatted = moment(row.end_time, "HH:mm:ss").format("hh:mmA");
    const callDateTime = `${row.call_date} ${startFormatted} - ${endFormatted}`;
    
    return [
      row.customer?.mobile || "N/A",
      row.agent?.agent_name || "N/A",
      callDateTime,
      row.formatted_duration || "N/A",
      `${currency || ''}${row.customer_amount_without_currency}` || "N/A",
      `${currency || ''}${row.agent_amount_without_currency}` || "N/A",
    ];
  });

  const footerRow = [
    "",
    "",
    "Total",
    formattedTotalDuration,
    `${currency || ''}${totalCustomerAmount.toFixed(2)}`,
    `${currency || ''}${totalAgentAmount.toFixed(2)}`,
  ];

  exportToPDF({
    fileName: "Call_Report",
    columns: [
      "Customer Mobile",
      "Agent Name",
      "Call Date & Time",
      "Duration",
      "Customer Amount",
      "Agent Amount",
    ],
    data: tableData,
    emptyDataMessage: "No call report available for export.",
    footerRow,
  });
};

const exportExcel = async () => {
  const rawData = await fetchAllDataWithoutPagination();
  const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);
  
  if (!allData.length) {
    toast.warn("No call report available for export.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
    });
    return;
  }

  // Calculate totals from ALL fetched data
  const totalDurationInSeconds = allData.reduce((acc, row) => {
    return acc + (parseInt(row.duration_seconds) || 0);
  }, 0);

  const hours = Math.floor(totalDurationInSeconds / 3600);
  const minutes = Math.floor((totalDurationInSeconds % 3600) / 60);
  const seconds = totalDurationInSeconds % 60;
  
  let formattedTotalDuration = '';
  if (hours > 0) formattedTotalDuration += `${hours}h `;
  if (minutes > 0) formattedTotalDuration += `${minutes}m `;
  if (seconds > 0 || (hours === 0 && minutes === 0)) formattedTotalDuration += `${seconds}s`;
  formattedTotalDuration = formattedTotalDuration.trim();

  const totalCustomerAmount = allData.reduce((acc, row) => {
    return acc + (parseFloat(row.customer_amount_without_currency) || 0);
  }, 0);

  const totalAgentAmount = allData.reduce((acc, row) => {
    return acc + (parseFloat(row.agent_amount_without_currency) || 0);
  }, 0);

  const tableData = allData.map((row: CallHistory) => {
    const startFormatted = moment(row.start_time, "HH:mm:ss").format("hh:mmA");
    const endFormatted = moment(row.end_time, "HH:mm:ss").format("hh:mmA");
    const callDateTime = `${row.call_date} ${startFormatted} - ${endFormatted}`;
    
    return {
      "Customer Mobile": row.customer?.mobile || "N/A",
      "Agent Name": row.agent?.agent_name || "N/A",
      "Call Date & Time": callDateTime,
      "Duration": row.formatted_duration || "N/A",
      "Customer Amount": `${currency || ''}${row.customer_amount_without_currency}` || "N/A",
      "Agent Amount": `${currency || ''}${row.agent_amount_without_currency}` || "N/A",
    };
  });

  // Add footer row
  const footerRow = {
    "Customer Mobile": "",
    "Agent Name": "",
    "Call Date & Time": "Total",
    "Duration": formattedTotalDuration,
    "Customer Amount": `${currency || ''}${totalCustomerAmount.toFixed(2)}`,
    "Agent Amount": `${currency || ''}${totalAgentAmount.toFixed(2)}`,
  };
  
  excelExportUtils(tableData, "Call_Report", "Call Report", footerRow);
};

  // const exportPDF = async () => {
  //   const rawData = await fetchAllDataWithoutPagination();
  //   const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);

  //   const tableData = allData.map((row) => {
  //     const start = new Date(`1970-01-01T${row.start_time}`);
  //     const end = new Date(`1970-01-01T${row.end_time}`);
  //     const duration = Math.floor((end.getTime() - start.getTime()) / 60000);

  //     return [
  //       row.customer?.mobile || "N/A",
  //       row.agent?.agent_name || "N/A",
  //       row.call_date,
  //       `${duration} mins`,
  //       `${row.customer_amount_without_currency}` || "N/A",
  //       `${row.agent_amount_without_currency}` || "N/A",
  //     ];
  //   });

  //   const footerRow = [
  //     "",
  //     "",
  //     "Total",
  //     `${totalDuration} mins`,
  //     `${totalCustomerAmount}`,
  //     `${totalAgentAmount}`,
  //   ];

  //   exportToPDF({
  //     fileName: "Call_Report",
  //     columns: [
  //       "Customer Mobile",
  //       "Agent Name",
  //       "Call Date",
  //       "Duration",
  //       "Customer Amount",
  //       "Agent Amount",
  //     ],
  //     data: tableData,
  //     emptyDataMessage: "No call report available for export.",
  //     footerRow,
  //   });
  // };

  // const exportExcel = async () => {
  //   const rawData = await fetchAllDataWithoutPagination();
  //   const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);
  //   if (!allData.length) {
  //     toast.warn("No call report available for export.", {
  //       position: "top-right",
  //       autoClose: 1000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //     });
  //     return;
  //   }
  //   const tableData = allData.map((row: CallHistory) => {
  //     const start = new Date(`1970-01-01T${row.start_time}`);
  //     const end = new Date(`1970-01-01T${row.end_time}`);
  //     const duration = Math.floor((end.getTime() - start.getTime()) / 60000);
  //     return {
  //       "Customer Mobile": row.customer?.mobile || "N/A",
  //       "Agent Name": row.agent?.agent_name || "N/A",
  //       "Call Date": row.call_date,
  //       Duration: `${duration} mins`,
  //       "Customer Amount": `${row.customer_amount}` || "N/A",
  //       "Agent Amount": `${row.agent_amount}` || "N/A",
  //     };
  //   });

  //   // Add footer row
  //   const footerRow = {
  //     "Customer Mobile": "",
  //     "Agent Name": "",
  //     "Call Date": "Total",
  //     Duration: `${totalDuration} mins`,
  //     "Customer Amount": `${
  //       currency ? ` ${currency}` : ""
  //     }${totalCustomerAmount}`,
  //     "Agent Amount": `${currency ? ` ${currency}` : ""}${totalAgentAmount}`,
  //   };
  //   excelExportUtils(tableData, "Call_Report", "Call Report", footerRow);
  // };

  return (
    <>
      <Breadcrumbs
        pageTitle="Call Report"
        parent="Reports"
        title="Call Report"
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            <Row className="align-items-center justify-content-end">
              <Col xl={2}>
                <div className="d-flex gap-2">
                  <Button
                    color="primary"
                    onClick={exportPDF}
                    className="d-flex justify-content-center align-items-center p-0"
                    style={{ width: "30px", height: "30px" }}
                    title="PDF"
                  >
                    <FaFilePdf size={16} />
                  </Button>
                  <Button
                    color="secondary"
                    onClick={exportExcel}
                    className="d-flex justify-content-center align-items-center p-0"
                    style={{ width: "30px", height: "30px" }}
                    title="EXCEL"
                  >
                    <FaFileExcel size={16} />
                  </Button>
                </div>
              </Col>

              <Col xl={3}>
                <div className="d-flex align-items-center">
                  <Input
                    type="select"
                    value={selectedAgent}
                    onChange={(e) => {
                      setSelectedAgent(e.target.value);
                      if (e.target.value === "") {
                        setSelectedAgent("");
                        fetchData(currentPage, perPage);
                      }
                    }}
                  >
                    <option value="">Filter by agent</option>
                    {agents.map((agent) => (
                      <option key={agent.id} value={agent.agent_name}>
                        {agent.agent_name}
                      </option>
                    ))}
                  </Input>
                </div>
              </Col>

              <Col xl={4}>
                <div className="d-flex align-items-center gap-2">
                  <label className="mb-0">From:</label>
                  <div style={{ flex: 1 }}>
                    <DatePicker
                      selected={fromDate}
                      onChange={(date: Date | null) => {
                        // Note the null type
                        setFromDate(date);
                        if (!date && !toDate) {
                          // Reset if both dates are empty
                          handleDateReset();
                        }
                      }}
                      dateFormat="yyyy-MM-dd"
                      className="form-control"
                      placeholderText="Start date"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>

                  <label className="mb-0">To:</label>
                  <div style={{ flex: 1 }}>
                    <DatePicker
                      selected={toDate}
                      onChange={(date: Date | null) => {
                        // Note the null type
                        setToDate(date);
                        if (!date && !fromDate) {
                          // Reset if both dates are empty
                          handleDateReset();
                        }
                      }}
                      dateFormat="yyyy-MM-dd"
                      className="form-control"
                      placeholderText="End date"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                  <Button
                    color="primary"
                    onClick={handleDateFilterClick}
                    title="Filter"
                  >
                    <i className="fa fa-filter" />
                  </Button>
                  <Button
                    color="danger"
                    onClick={handleDateReset}
                    title="Reset Date Filter"
                  >
                    <i className="fa fa-refresh" />
                  </Button>
                </div>
              </Col>

              <Col xl={3}>
                <div className="d-flex align-items-center">
                  <Input
                    type="text"
                    placeholder="Search"
                    value={filterText}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFilterText(value);
                      if (value === "") {
                        handleSearchReset();
                      }
                    }}
                    className="me-2"
                  />
                  <Button
                    color="primary"
                    onClick={handleSearchClick}
                    className="me-2"
                    title="Search"
                  >
                    <i className="fa fa-search" />
                  </Button>
                  <Button
                    color="danger"
                    onClick={handleSearchReset}
                    title="Reset Search"
                  >
                    <i className="fa fa-refresh" />
                  </Button>
                </div>
              </Col>
            </Row>

            <div className="table-responsive custom-scrollbar mt-3">
              <DataTable
                data={columnsData}
                columns={getCallHistoryColumns()}
                highlightOnHover
                striped
                customStyles={customStyles}
                pagination
                paginationServer
                paginationPerPage={perPage}
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationDefaultPage={currentPage}
                responsive
                conditionalRowStyles={conditionalRowStyles}
              />
            </div>
          </CardBody>
        </Card>
      </Col>

      <ToastContainer />
    </>
  );
}

// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Col, Button, Spinner, Row, Input } from "reactstrap";
// import DataTable from "react-data-table-component";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios from "axios";
// import useCurrency, { baseUrl } from "../../../Utils/FileUpload";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaFilePdf, FaFileExcel } from "react-icons/fa";
// import moment from "moment";
// import { exportToPDF } from "../../../Utils/pdfExportUtils";
// import { excelExportUtils } from "../../../Utils/excelExportUtils";
// interface CallHistory {
//   id: string;
//   start_time: string;
//   end_time: string;
//   customer: {
//     mobile: string;
//   };
//   agent: {
//     agent_name: string;
//     id: string;
//   };
//   call_date: string;
//   duration: number;
//   customer_amount: number | string;
//   agent_amount: number | string;
//   formatted_duration: string;
//   customer_amount_without_currency: number | string;
//   agent_amount_without_currency: number | string;
// }

// interface CallHistoryWithFooter extends CallHistory {
//   isFooter?: boolean;
// }
// export default function CallReport() {
//   const [filterText, setFilterText] = useState("");
//   const [filteredItems, setFilteredItems] = useState<CallHistory[]>([]);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem("token");
//   const [fromDate, setFromDate] = useState<Date | null>(null);
//   const [toDate, setToDate] = useState<Date | null>(null);
//   const { currency } = useCurrency();
//   const [totalRows, setTotalRows] = useState<number>(0);
//   const [perPage, setPerPage] = useState<number>(10);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [prevPageBeforeSearch, setPrevPageBeforeSearch] = useState<number>(1);
//   const [searchTriggered, setSearchTriggered] = useState<boolean>(false);

//   const fetchData = async (page = 1, perPage = 10) => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${baseUrl}call_history/getallreport`, {
//         params: {
//           page,
//           per_page: perPage,
//           search: searchTriggered ? filterText : "",
//           from_date: fromDate ? fromDate.toISOString().split("T")[0] : null,
//           to_date: toDate ? toDate.toISOString().split("T")[0] : null,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       // console.log(response);

//       const data: CallHistory[] = response.data.data;
//       // console.log(data, "data");
//       setFilteredItems(data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(currentPage, perPage);
//   }, [currentPage, perPage]);

//   const handlePageChange = (page: number) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = async (newPerPage: number, page: number) => {
//     setPerPage(newPerPage);
//     setCurrentPage(1);
//     await fetchData(1, newPerPage);
//   };

//   const handleSearchClick = async () => {
//     setLoading(true);
//     try {
//       // First update all state
//       setSearchTriggered(true);
//       setPrevPageBeforeSearch(currentPage);
//       setCurrentPage(1);

//       // Force state update before API call
//       await new Promise((resolve) => setTimeout(resolve, 0));

//       // Then make the API call
//       const response = await axios.get(`${baseUrl}call_history/getallreport`, {
//         params: {
//           page: 1,
//           per_page: perPage,
//           search: filterText, // Always include search text when button is clicked
//           from_date: fromDate?.toISOString().split("T")[0],
//           to_date: toDate?.toISOString().split("T")[0],
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setFilteredItems(response.data.data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//     } catch (error) {
//       console.error("Search failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDateFilterClick = () => {
//     if (fromDate && toDate && fromDate > toDate) {
//       toast.error("From date cannot be greater than To date.");
//       return;
//     }
//     setSearchTriggered(true);
//     fetchData(currentPage, perPage);
//   };

//   const handleFullReset = () => {
//     // Reset all filter states
//     setFilterText("");
//     setFromDate(null);
//     setToDate(null);
//     setSearchTriggered(false);
//     setCurrentPage(currentPage);
//     fetchData(currentPage, perPage);
//   };

//   useEffect(() => {
//     if (
//       !searchTriggered &&
//       filterText === "" &&
//       fromDate === null &&
//       toDate === null
//     ) {
//       fetchData(currentPage, perPage);
//     }
//   }, [searchTriggered, filterText, fromDate, toDate]);

//   const getCallHistoryColumns = () => {
//     return [
//       {
//         name: "Customer Mobile",
//         selector: (row: CallHistory) => row.customer?.mobile,
//         // sortable: true,
//       },
//       {
//         name: "Agent Name",
//         selector: (row: CallHistory) => row.agent?.agent_name,
//         // sortable: true,
//       },
//       {
//         name: "Call Date",
//         cell: (row: CallHistoryWithFooter) => {
//           if (row.isFooter) {
//             return <>Total</>; // just show "Total" for the footer
//           }
//           const startFormatted = moment(row.start_time, "HH:mm:ss").format(
//             "hh:mmA"
//           );
//           const endFormatted = moment(row.end_time, "HH:mm:ss").format(
//             "hh:mmA"
//           );
//           return <>{`${row.call_date} ${startFormatted} - ${endFormatted}`}</>;
//         },
//       },
//       {
//         name: "Duration",
//         cell: (row: CallHistoryWithFooter) => {
//           if (row.isFooter) {
//             return `${row.formatted_duration || row.duration + " mins"}`;
//           }
//           return row.formatted_duration || "N/A";
//         },
//       },
//       {
//         name: "Customer Amount",
//         selector: (row: CallHistory) => `${row.customer_amount}` || "N/A",
//       },
//       {
//         name: "Agent Amount",
//         selector: (row: CallHistory) => `${row.agent_amount}` || "N/A",
//       },
//     ];
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   const fetchAllDataWithoutPagination = async () => {
//     try {
//       // console.log(fromDate, toDate, filterText);
//       const response = await axios.get(
//         `${baseUrl}call_history/getallreportnopagination`,
//         {
//           params: {
//             search: searchTriggered ? filterText : "", // Use the current search filter
//             from_date: fromDate ? fromDate.toISOString().split("T")[0] : null, // Use the current from date
//             to_date: toDate ? toDate.toISOString().split("T")[0] : null, // Use the current to date
//           },
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       // console.log(response.data.data, "data");
//       return response.data.data; // Return the fetched data
//     } catch (error) {
//       console.error("Error fetching all data without pagination:", error);
//       return []; // Return an empty array on error
//     }
//   };

//   const calculateTotals = () => {
//     const totalDuration = filteredItems.reduce((acc, row) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const diff = Math.floor((end.getTime() - start.getTime()) / 60000);
//       return acc + diff;
//     }, 0);

//     const totalCustomerAmount = filteredItems.reduce((acc, row) => {
//       const amount = parseFloat(
//         (row as any).customer_amount_without_currency || "0"
//       );
//       return acc + amount;
//     }, 0);

//     const totalAgentAmount = filteredItems.reduce((acc, row) => {
//       const amount = parseFloat(
//         (row as any).agent_amount_without_currency || "0"
//       );
//       return acc + amount;
//     }, 0);

//     return {
//       totalDuration,
//       totalCustomerAmount,
//       totalAgentAmount,
//     };
//   };

//   const { totalDuration, totalCustomerAmount, totalAgentAmount } =
//     calculateTotals();
//   const columnsData: CallHistoryWithFooter[] = [
//     ...filteredItems,
//     {
//       isFooter: true,
//       customer: { mobile: "" },
//       agent: { agent_name: "", id: "footer" },
//       call_date: "Total",
//       duration: totalDuration,
//       formatted_duration: `${totalDuration} mins`,
//       customer_amount: `${
//         currency ? ` ${currency}` : ""
//       }${totalCustomerAmount}`,
//       agent_amount: `${currency ? ` ${currency}` : ""}${totalAgentAmount}`,
//       customer_amount_without_currency: totalCustomerAmount,
//       agent_amount_without_currency: totalAgentAmount,
//       id: "",
//       start_time: "",
//       end_time: "",
//     },
//   ];

//   const customStyles = {
//     headCells: {
//       style: {
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#308e87",
//         backgroundColor: "#f8f9fa",
//         borderBottom: "2px solid #308e87",
//       },
//     },
//     rows: {
//       style: {
//         borderBottom: "1px solid #dee2e6",
//       },
//     },
//     table: {
//       style: {
//         border: "1px solid #dee2e6",
//         borderRadius: "8px",
//       },
//     },
//   };

//   const conditionalRowStyles = [
//     {
//       when: (row: any) => row.isFooter === true,
//       style: {
//         fontWeight: "800",
//         backgroundColor: "#f8f9fa",
//         color: "#308e87",
//         borderTop: "2px solid #dee2e6",
//         fontSize: "16px",
//       },
//     },
//   ];

//   const exportPDF = async () => {
//     const rawData = await fetchAllDataWithoutPagination();
//     const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);

//     const tableData = allData.map((row) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const duration = Math.floor((end.getTime() - start.getTime()) / 60000);

//       return [
//         row.customer?.mobile || "N/A",
//         row.agent?.agent_name || "N/A",
//         row.call_date,
//         `${duration} mins`,
//         `${row.customer_amount_without_currency}` || "N/A",
//         `${row.agent_amount_without_currency}` || "N/A",
//       ];
//     });

//     const footerRow = [
//       "",
//       "",
//       "Total",
//       `${totalDuration} mins`,
//       `${totalCustomerAmount}`,
//       `${totalAgentAmount}`,
//     ];

//     exportToPDF({
//       fileName: "Call_Report",
//       columns: [
//         "Customer Mobile",
//         "Agent Name",
//         "Call Date",
//         "Duration",
//         "Customer Amount",
//         "Agent Amount",
//       ],
//       data: tableData,
//       emptyDataMessage: "No call report available for export.",
//       footerRow,
//     });
//   };

//     const exportExcel = async () => {
//     const rawData = await fetchAllDataWithoutPagination();
//     const allData = Array.isArray(rawData) ? rawData : Object.values(rawData);
//     if (!allData.length) {
//       toast.warn("No call report available for export.", {
//         position: "top-right",
//         autoClose: 1000,
//         hideProgressBar: false,
//         closeOnClick: true,
//       });
//       return;
//     }
//     const tableData = allData.map((row: CallHistory) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const duration = Math.floor((end.getTime() - start.getTime()) / 60000);
//       return {
//         "Customer Mobile": row.customer?.mobile || "N/A",
//         "Agent Name": row.agent?.agent_name || "N/A",
//         "Call Date": row.call_date,
//         Duration: `${duration} mins`,
//         "Customer Amount": `${row.customer_amount}` || "N/A",
//         "Agent Amount": `${row.agent_amount}` || "N/A",
//       };
//     });

//     // Add footer row
//     const footerRow = {
//       "Customer Mobile": "",
//       "Agent Name": "",
//       "Call Date": "Total",
//       Duration: `${totalDuration} mins`,
//       "Customer Amount": `${
//         currency ? ` ${currency}` : ""
//       }${totalCustomerAmount}`,
//       "Agent Amount": `${currency ? ` ${currency}` : ""}${totalAgentAmount}`,
//     };
//      excelExportUtils(
//         tableData,
//         "Call_Report",
//         "Call Report",
//         footerRow
//       );
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle="Call Report"
//         parent="Reports"
//         title="Call Report"
//       />
//       <Col xl={12} className="mb-lg-3">
//         <Card>
//           <CardBody>
//             <Row className="align-items-center justify-content-end">
//               <Col xl={2}>
//                 <div className="d-flex gap-2">
//                   <Button
//                     color="primary"
//                     onClick={exportPDF}
//                     className="d-flex justify-content-center align-items-center p-0"
//                     style={{ width: "30px", height: "30px" }}
//                     title="PDF"
//                   >
//                     <FaFilePdf size={16} />
//                   </Button>
//                   <Button
//                     color="secondary"
//                     onClick={exportExcel}
//                     className="d-flex justify-content-center align-items-center p-0"
//                     style={{ width: "30px", height: "30px" }}
//                     title="EXCEL"
//                   >
//                     <FaFileExcel size={16} />
//                   </Button>
//                 </div>
//               </Col>

//               <Col xl={3}></Col>

//               <Col xl={4}>
//                 <div className="d-flex align-items-center gap-2">
//                   <label className="mb-0">From:</label>
//                   <div style={{ flex: 1 }}>
//                     <DatePicker
//                       selected={fromDate}
//                       onChange={(date: Date | null) => {
//                         // Note the null type
//                         setFromDate(date);
//                         if (!date && !toDate) {
//                           // Reset if both dates are empty
//                           handleFullReset();
//                         }
//                       }}
//                       dateFormat="yyyy-MM-dd"
//                       className="form-control"
//                       placeholderText="Start date"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                   </div>

//                   <label className="mb-0">To:</label>
//                   <div style={{ flex: 1 }}>
//                     <DatePicker
//                       selected={toDate}
//                       onChange={(date: Date | null) => {
//                         // Note the null type
//                         setToDate(date);
//                         if (!date && !fromDate) {
//                           // Reset if both dates are empty
//                           handleFullReset();
//                         }
//                       }}
//                       dateFormat="yyyy-MM-dd"
//                       className="form-control"
//                       placeholderText="End date"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                   </div>
//                   <Button
//                     color="primary"
//                     onClick={handleDateFilterClick}
//                     title="Filter"
//                   >
//                     <i className="fa fa-filter" />
//                   </Button>
//                 </div>
//               </Col>

//               <Col xl={3}>
//                 <div className="d-flex align-items-center">
//                   <Input
//                     type="text"
//                     placeholder="Search"
//                     value={filterText}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setFilterText(value);
//                       if (value === "") {
//                         handleFullReset();
//                       }
//                     }}
//                     className="me-2"
//                   />
//                   <Button
//                     color="primary"
//                     onClick={handleSearchClick}
//                     className="me-2"
//                     title="Search"
//                   >
//                     <i className="fa fa-search" />
//                   </Button>
//                   <Button
//                     color="danger"
//                     onClick={handleFullReset} // Changed to use the common reset
//                     title="Reset All Filters"
//                   >
//                     <i className="fa fa-refresh" />
//                   </Button>
//                 </div>
//               </Col>
//             </Row>

//             <div className="table-responsive custom-scrollbar mt-3">
//               <DataTable
//                 data={columnsData}
//                 columns={getCallHistoryColumns()}
//                 highlightOnHover
//                 striped
//                 customStyles={customStyles}
//                 pagination
//                 paginationServer
//                 paginationPerPage={perPage}
//                 paginationTotalRows={totalRows}
//                 onChangePage={handlePageChange}
//                 onChangeRowsPerPage={handlePerRowsChange}
//                 paginationDefaultPage={currentPage}
//                 responsive
//                 conditionalRowStyles={conditionalRowStyles}
//               />
//             </div>
//           </CardBody>
//         </Card>
//       </Col>

//       <ToastContainer />
//     </>
//   );
// }

// //
// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Col, Button, Spinner, Row, Input } from "reactstrap";
// import DataTable from "react-data-table-component";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios from "axios";
// import useCurrency, { baseUrl } from "../../../Utils/FileUpload";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { FaFilePdf, FaFileExcel } from "react-icons/fa";
// import moment from "moment";
// interface CallHistory {
//   id: string;
//   start_time: string;
//   end_time: string;
//   customer: {
//     mobile: string;
//   };
//   agent: {
//     agent_name: string;
//     id: string;
//   };
//   call_date: string;
//   duration: number;
//   customer_amount: number;
//   agent_amount: number;
//   formattedDuration:string;
// }

// interface CallHistoryWithFooter extends CallHistory {
//   isFooter?: boolean;
// }
// export default function CallReport() {
//   const [filterText, setFilterText] = useState("");
//   const [filteredItems, setFilteredItems] = useState<CallHistory[]>([]);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem("token");
//   const [fromDate, setFromDate] = useState<Date | null>(null);
//   const [toDate, setToDate] = useState<Date | null>(null);
//   const { currency } = useCurrency();
//   const [totalRows, setTotalRows] = useState<number>(0);
//   const [perPage, setPerPage] = useState<number>(10);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [prevPageBeforeSearch, setPrevPageBeforeSearch] = useState<number>(1);
//   const [searchTriggered, setSearchTriggered] = useState<boolean>(false);

//   const fetchData = async (page = 1, perPage = 10) => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${baseUrl}call_history/getallreport`, {
//         params: {
//           page,
//           per_page: perPage,
//           search: searchTriggered ? filterText : "",
//           from_date: fromDate ? fromDate.toISOString().split("T")[0] : null,
//           to_date: toDate ? toDate.toISOString().split("T")[0] : null,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       console.log(response);

//       const data: CallHistory[] = response.data.data;
//       setFilteredItems(data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(currentPage, perPage);
//   }, [currentPage, perPage]);

//   const handlePageChange = (page: number) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = async (newPerPage: number, page: number) => {
//     setPerPage(newPerPage);
//     setCurrentPage(1);
//     await fetchData(1, newPerPage);
//   };

//   const handleSearchClick = async () => {
//     setLoading(true);
//     try {
//       // First update all state
//       setSearchTriggered(true);
//       setPrevPageBeforeSearch(currentPage);
//       setCurrentPage(1);

//       // Force state update before API call
//       await new Promise((resolve) => setTimeout(resolve, 0));

//       // Then make the API call
//       const response = await axios.get(`${baseUrl}call_history/getallreport`, {
//         params: {
//           page: 1,
//           per_page: perPage,
//           search: filterText, // Always include search text when button is clicked
//           from_date: fromDate?.toISOString().split("T")[0],
//           to_date: toDate?.toISOString().split("T")[0],
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setFilteredItems(response.data.data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//     } catch (error) {
//       console.error("Search failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDateFilterClick = () => {
//     if (fromDate && toDate && fromDate > toDate) {
//       toast.error("From date cannot be greater than To date.");
//       return;
//     }
//     if (!fromDate && !toDate) {
//       toast.error("Please select at least one date.");
//       return;
//     }
//     setSearchTriggered(true);
//     fetchData(currentPage, perPage);
//   };
//   const handleFullReset = () => {
//     // Reset all filter states
//     setFilterText("");
//     setFromDate(null);
//     setToDate(null);
//     setSearchTriggered(false);
//     setCurrentPage(currentPage);
//     fetchData(currentPage, perPage);
//   };
//   useEffect(() => {
//     // Only run for automatic resets, not manual searches
//     console.log(searchTriggered, filterText, fromDate, toDate);

//     if (
//       !searchTriggered &&
//       filterText === "" &&
//       fromDate === null &&
//       toDate === null
//     ) {
//       fetchData(currentPage, perPage);
//     }
//   }, [searchTriggered, filterText, fromDate, toDate]);

//   const getCallHistoryColumns = () => {
//     return [
//       {
//         name: "Customer Mobile",
//         selector: (row: CallHistory) => row.customer?.mobile,
//         // sortable: true,
//       },
//       {
//         name: "Agent Name",
//         selector: (row: CallHistory) => row.agent?.agent_name,
//         // sortable: true,
//       },
//       {
//         name: "Call Date",
//         cell: (row: CallHistoryWithFooter) => {
//           if (row.isFooter) {
//             return <>Total</>; // just show "Total" for the footer
//           }
//           const startFormatted = moment(row.start_time, "HH:mm:ss").format(
//             "hh:mmA"
//           );
//           const endFormatted = moment(row.end_time, "HH:mm:ss").format(
//             "hh:mmA"
//           );
//           return <>{`${row.call_date} ${startFormatted} - ${endFormatted}`}</>;
//         },
//       },
//       {
//         name: "Duration",
//         cell: (row: CallHistoryWithFooter) => {
//           if (row.isFooter) {
//             return `${row.duration} mins`;
//           }

//           return `${row.formattedDuration}`;
//         },
//       },
//       {
//         name: "Customer Amount",
//         selector: (row: CallHistory) =>
//           `${row.customer_amount}` || "N/A",
//       },
//       {
//         name: "Agent Amount",
//         selector: (row: CallHistory) =>
//           `${row.agent_amount}` || "N/A",
//       },
//     ];
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   const fetchAllDataWithoutPagination = async () => {
//     try {
//       const response = await axios.get(
//         `${baseUrl}call_history/getallreportnopagination`,
//         {
//           params: {
//             search: searchTriggered ? filterText : "", // Use the current search filter
//             from_date: fromDate ? fromDate.toISOString().split("T")[0] : null, // Use the current from date
//             to_date: toDate ? toDate.toISOString().split("T")[0] : null, // Use the current to date
//           },
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       return response.data.data; // Return the fetched data
//     } catch (error) {
//       console.error("Error fetching all data without pagination:", error);
//       return []; // Return an empty array on error
//     }
//   };

//   const calculateTotals = () => {
//     const totalDuration = filteredItems.reduce((acc, row) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const diff = Math.floor((end.getTime() - start.getTime()) / 60000);
//       return acc + diff;
//     }, 0);

//     const totalCustomerAmount = filteredItems.reduce((acc, row) => {
//       return acc + parseFloat(String(row.customer_amount) || "0");
//     }, 0);

//     const totalAgentAmount = filteredItems.reduce((acc, row) => {
//       return acc + parseFloat(String(row.agent_amount) || "0");
//     }, 0);
//     // console.log(totalDuration);
//     return {
//       totalDuration,
//       totalCustomerAmount,
//       totalAgentAmount,
//     };
//   };

//   const { totalDuration, totalCustomerAmount, totalAgentAmount } =
//     calculateTotals();
//   const columnsData: CallHistoryWithFooter[] = [
//     ...filteredItems,
//     {
//       isFooter: true,
//       customer: { mobile: "" }, // This should be a string
//       agent: { agent_name: "", id: "footer" }, // Add missing 'id' for agent
//       call_date: "Total",
//       duration: totalDuration, // Ensure this is a number
//       formattedDuration:"",
//       customer_amount: Number(totalCustomerAmount.toFixed(2)),
//       agent_amount: Number(totalAgentAmount.toFixed(2)),
//       id: "", // Provide a placeholder for the 'id' field
//       start_time: "", // Provide a placeholder for 'start_time'
//       end_time: "", // Provide a placeholder for 'end_time'
//     },
//   ];

//   const customStyles = {
//     headCells: {
//       style: {
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#308e87",
//         backgroundColor: "#f8f9fa",
//         borderBottom: "2px solid #308e87",
//       },
//     },
//     rows: {
//       style: {
//         borderBottom: "1px solid #dee2e6",
//       },
//     },
//     table: {
//       style: {
//         border: "1px solid #dee2e6",
//         borderRadius: "8px",
//       },
//     },
//   };

//   const conditionalRowStyles = [
//     {
//       when: (row: any) => row.isFooter === true,
//       style: {
//         fontWeight: "800",
//         backgroundColor: "#f8f9fa",
//         color: "#308e87",
//         borderTop: "2px solid #dee2e6",
//         fontSize: "16px",
//       },
//     },
//   ];

//   const exportPDF = async () => {
//     const allData = await fetchAllDataWithoutPagination(); // Fetch all data without pagination
//     console.log(allData,"allData")
//     if (!allData.length) {
//       toast.warn("No call report available for export.", {
//         position: "top-right",
//         autoClose: 1000,
//         hideProgressBar: false,
//         closeOnClick: true,
//       });
//       return;
//     }
//     const doc = new jsPDF();
//     const tableColumn = [
//       "Customer Mobile",
//       "Agent Name",
//       "Call Date",
//       "Duration",
//       "Customer Amount",
//       "Agent Amount",
//     ];
// const parseAmount = (amount: string | number) =>
//   parseFloat(String(amount).replace(/[^\d.]/g, "") || "0");

// const totalCustomerAmount = filteredItems.reduce((acc, row) => {
//   return acc + parseAmount(row.customer_amount);
// }, 0);

// const totalAgentAmount = filteredItems.reduce((acc, row) => {
//   return acc + parseAmount(row.agent_amount);
// }, 0);
//     const tableRows = allData.map((row: CallHistory) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const duration = Math.floor((end.getTime() - start.getTime()) / 60000);

//       return [
//         row.customer?.mobile || "N/A",
//         row.agent?.agent_name || "N/A",
//         row.call_date,
//         `${duration} mins`,
//         `${row.customer_amount}` || "N/A",
//         `${row.agent_amount}` || "N/A",
//       ];
//     });

//     // Add footer row
//     const footerRow = [
//       "",
//       "", // Empty for Agent Name
//       "Total", // Empty for Call Date
//       `${totalDuration} mins`, // Total Duration
//       `${totalCustomerAmount}`, // Total Customer Amount
//       `${totalAgentAmount}`, // Total Agent Amount
//     ];
//     tableRows.push(footerRow);

//     autoTable(doc, {
//       head: [tableColumn],
//       body: tableRows,
//       startY: 20,
//     });

//     doc.save("Call_Report.pdf");
//   };

//   const exportExcel = async () => {
//     const allData = await fetchAllDataWithoutPagination(); // Fetch all data without pagination
//     if (!allData.length) {
//       toast.warn("No call report available for export.", {
//         position: "top-right",
//         autoClose: 1000,
//         hideProgressBar: false,
//         closeOnClick: true,
//       });
//       return;
//     }
//     const tableData = allData.map((row: CallHistory) => {
//       const start = new Date(`1970-01-01T${row.start_time}`);
//       const end = new Date(`1970-01-01T${row.end_time}`);
//       const duration = Math.floor((end.getTime() - start.getTime()) / 60000);
//       return {
//         "Customer Mobile": row.customer?.mobile || "N/A",
//         "Agent Name": row.agent?.agent_name || "N/A",
//         "Call Date": row.call_date,
//         Duration: `${duration} mins`,
//         "Customer Amount":
//           `${row.customer_amount}` || "N/A",
//         "Agent Amount":
//           `${row.agent_amount}` || "N/A",
//       };
//     });

//     // Add footer row
//     const footerRow = {
//       "Customer Mobile": "",
//       "Agent Name": "",
//       "Call Date": "Total",
//       Duration: `${totalDuration} mins`,
//       "Customer Amount": `${totalCustomerAmount}${
//         currency ? ` ${currency}` : ""
//       }`,
//       "Agent Amount": `${totalAgentAmount}`,
//     };
//     tableData.push(footerRow);

//     // Create worksheet and workbook
//     const worksheet = XLSX.utils.json_to_sheet(tableData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Call_Report");

//     // Generate Excel buffer
//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });

//     // Save with FileSaver
//     const blob = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
//     });
//     saveAs(blob, "Call_Report.xlsx");
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle="Call Report"
//         parent="Reports"
//         title="Call Report"
//       />
//       <Col xl={12} className="mb-lg-3">
//         <Card>
//           <CardBody>
//             <Row className="align-items-center justify-content-end">
//               <Col xl={2}>
//                 <div className="d-flex gap-2">
//                   <Button
//                     color="primary"
//                     onClick={exportPDF}
//                     className="d-flex justify-content-center align-items-center p-0"
//                     style={{ width: "30px", height: "30px" }}
//                   >
//                     <FaFilePdf size={16} />
//                   </Button>
//                   <Button
//                     color="secondary"
//                     onClick={exportExcel}
//                     className="d-flex justify-content-center align-items-center p-0"
//                     style={{ width: "30px", height: "30px" }}
//                   >
//                     <FaFileExcel size={16} />
//                   </Button>
//                 </div>
//               </Col>

//               <Col xl={3}></Col>

//               <Col xl={4}>
//                 <div className="d-flex align-items-center gap-2">
//                   <label className="mb-0">From:</label>
//                   <div style={{ flex: 1 }}>
//                     <DatePicker
//                       selected={fromDate}
//                       onChange={(date: Date | null) => {
//                         // Note the null type
//                         setFromDate(date);
//                         if (!date && !toDate) {
//                           // Reset if both dates are empty
//                           handleFullReset();
//                         }
//                       }}
//                       dateFormat="yyyy-MM-dd"
//                       className="form-control"
//                       placeholderText="Start date"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                   </div>

//                   <label className="mb-0">To:</label>
//                   <div style={{ flex: 1 }}>
//                     <DatePicker
//                       selected={toDate}
//                       onChange={(date: Date | null) => {
//                         // Note the null type
//                         setToDate(date);
//                         if (!date && !fromDate) {
//                           // Reset if both dates are empty
//                           handleFullReset();
//                         }
//                       }}
//                       dateFormat="yyyy-MM-dd"
//                       className="form-control"
//                       placeholderText="End date"
//                       showMonthDropdown
//                       showYearDropdown
//                       dropdownMode="select"
//                     />
//                   </div>
//                   <Button color="primary" onClick={handleDateFilterClick}>
//                     <i className="fa fa-filter" />
//                   </Button>
//                 </div>
//               </Col>

//               <Col xl={3}>
//                 <div className="d-flex align-items-center">
//                   <Input
//                     type="text"
//                     placeholder="Search"
//                     value={filterText}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setFilterText(value);
//                       if (value === "") {
//                         handleFullReset();
//                       }
//                     }}
//                     className="me-2"
//                   />
//                   <Button
//                     color="primary"
//                     onClick={handleSearchClick}
//                     className="me-2"
//                     title="Search"
//                   >
//                     <i className="fa fa-search" />
//                   </Button>
//                   <Button
//                     color="danger"
//                     onClick={handleFullReset} // Changed to use the common reset
//                     title="Reset All Filters"
//                   >
//                     <i className="fa fa-refresh" />
//                   </Button>
//                 </div>
//               </Col>
//             </Row>

//             <div className="table-responsive custom-scrollbar mt-3">
//               <DataTable
//                 data={columnsData}
//                 columns={getCallHistoryColumns()}
//                 highlightOnHover
//                 striped
//                 customStyles={customStyles}
//                 pagination
//                 paginationServer
//                 paginationPerPage={perPage}
//                 paginationTotalRows={totalRows}
//                 onChangePage={handlePageChange}
//                 onChangeRowsPerPage={handlePerRowsChange}
//                 paginationDefaultPage={currentPage}
//                 responsive
//                 conditionalRowStyles={conditionalRowStyles}
//               />
//             </div>
//           </CardBody>
//         </Card>
//       </Col>

//       <ToastContainer />
//     </>
//   );
// }
//
